module.exports = __webpack_public_path__ + "static/media/image@3x.8b6b215e.png";